import insightsDark from "../assets/images/insightsDark.png";
import insightsWhite from "../assets/images/insightsWhite.png";
import dashboardDark from "../assets/images/dashboardDark.png";
import dashboardWhite from "../assets/images/dashboardWhite.png";
import profileDark from "../assets/images/profileDark.png";
import profileWhite from "../assets/images/profileWhite.png";

const navItems = [
  {
    title: "Home",

    href: "/",
  },

  {
    title: "Work",

    href: "/work",
  },

  {
    title: "About",

    href: "/about",
  },

  {
    title: "Contact",

    href: "/contact",
  },
];

const tinyMenuItems = [
  {
    icon: { iconLight: profileWhite, iconDark: profileDark },
    title: "Profile",
    href: "/dashboard/profile",
  },

  {
    icon: { iconLight: dashboardWhite, iconDark: dashboardDark },
    title: "Project Management",
    href: "/dashboard/landing",
  },

  {
    icon: { iconLight: insightsWhite, iconDark: insightsDark },
    title: "Insights And Analytics",
    href: "/dashboard/insights-and-analytics",
  },
];

export { navItems, tinyMenuItems };
